import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { faEdit, faEye, faFilter, faPlus, faPrint } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { removerAcentos } from '../../../../../utils'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { useState } from 'react'
import { ModalFiltroAbastecimento } from '../filtro'
import dayjs from 'dayjs'
import { FiltroAvancado, filtrarAvancado } from '../filtro/meta'
import { FornecedorItens } from '../../../../../services/Fornecedores'
import { PropriedadeItens } from '../../../../../services/Propriedades'
import { Box } from '../../../../../Components/CustomUi/box'
import { temInconsistencia, valorDoAbastecimento } from '../../meta'
import { IconeInconsistencia } from './components/iconeInconsistencia'
import { ImprimirRelatorio } from './components/imprimirRelatorio'

const tags_acerto = {
    reembolso: { label: 'Reembolso', cor: 'blue' },
    desconto: { label: 'Desc. na folha', cor: 'volcano' },
    empresa: { label: 'Empresa', cor: 'green' },
}

function tipoAcerto(necessario_reembolso: boolean, desconto_folha: boolean) {
    if (necessario_reembolso) return tags_acerto.reembolso
    if (desconto_folha) return tags_acerto.desconto
    return tags_acerto.empresa
}

interface PropsTabela {
    loading: boolean
    /**Carregamento da lista completa, que é a base da tabela quando há filtro avançado aplicado */
    carregando_total: boolean
    pagination: number
    setPagination: React.Dispatch<React.SetStateAction<number>>
    page: number
    setPage: React.Dispatch<React.SetStateAction<number>>
    total: number
    listar_abastecimento: any[]
    /**Postos e propriedades vêm da tela principal, são as mesmas listas usadas no cadastro */
    data_postos: FornecedorItens[]
    data_propriedades: PropriedadeItens[]
    abrir: Function
    permissao: ItensPerUserLogged
    editar: Function
    deletar: Function
    buscar_tabela: string
    setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
    confirmar_exclusao: boolean
    setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
    id_item_atual: number
    setId_item_atual: React.Dispatch<React.SetStateAction<number>>
    nome_item_atual: string
    setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
    fake_loading: boolean
    total_geral: any[]
}

export const TabelaAbastecimento: React.FC<PropsTabela> = ({
    loading,
    carregando_total,
    pagination,
    setPagination,
    page,
    setPage,
    total,
    listar_abastecimento,
    data_postos,
    data_propriedades,
    abrir,
    permissao,
    editar,
    deletar,
    buscar_tabela,
    setBuscar_tabela,
    confirmar_exclusao,
    setConfirmar_exclusao,
    id_item_atual,
    setId_item_atual,
    nome_item_atual,
    setNome_item_atual,
    fake_loading,
    total_geral,
}) => {

    const [abrirModal, setAbrirModal] = useState<boolean>(false)
    /**Campos do filtro avançado, aplicados na lista somente ao clicar em `Filtrar` */
    const [filtro_aplicado, setFiltro_aplicado] = useState<FiltroAvancado>(null)
    const [tab_local, setTab_local] = useState<string>('Posto')
    const [intervalo_datas, setIntervalo_datas] = useState<any[]>([])
    const [fornecedor_selecionado, setFornecedor_selecionado] = useState<string>('')
    const [fornecedor_selecionado_id, setFornecedor_selecionado_id] = useState<number>(null)
    const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
    const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(null)
    const [responsavel_selecionado, setResponsavel_selecionado] = useState<string>('')
    const [responsavel_selecionado_id, setResponsavel_selecionado_id] = useState<number>(null)
    const [frota_selecionada, setFrota_selecionada] = useState<string>('')
    const [forma_pagamento, setForma_pagamento] = useState<string>('')
    const [forma_pagamento_id, setForma_pagamento_id] = useState<number>(null)
    const [reembolsados, setReembolsados] = useState<boolean>(false)
    const [descontados_folha, setDescontados_folha] = useState<boolean>(false)
    const [somente_inconsistentes, setSomente_inconsistentes] = useState<boolean>(false)

    function buscarAbastecimento(buscar_nome: string) {
        const palavraSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.usuario_nome))
            return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    function abrirModalFiltro() {
        setAbrirModal(true)
    }

    function fecharModalAbasFiltro() {
        setAbrirModal(false)
    }

    function limparFiltros() {
        setTab_local('Posto')
        setIntervalo_datas([])
        setFornecedor_selecionado('')
        setFornecedor_selecionado_id(null)
        setPropriedade_selecionada('')
        setPropriedade_selecionada_id(null)
        setResponsavel_selecionado('')
        setResponsavel_selecionado_id(null)
        setFrota_selecionada('')
        setForma_pagamento('')
        setForma_pagamento_id(null)
        setReembolsados(false)
        setDescontados_folha(false)
        setSomente_inconsistentes(false)
    }

    function filtrarAbastecimento() {
        setFiltro_aplicado({
            local: tab_local,
            intervalo_datas: intervalo_datas,
            nome_fornecedor: fornecedor_selecionado,
            cod_propriedade: propriedade_selecionada_id,
            cod_responsavel: responsavel_selecionado_id,
            frota: frota_selecionada,
            cod_forma_pagamento: forma_pagamento_id,
            reembolsados: reembolsados,
            descontados_folha: descontados_folha,
            somente_inconsistentes: somente_inconsistentes,
        })
        // a contagem de páginas muda com o filtro, então a listagem volta para a primeira
        setPage(1)
        fecharModalAbasFiltro()
    }

    /**Com o filtro avançado aplicado a base passa a ser a lista completa: a listagem paginada
     * traz somente a página atual, então o filtro enxergaria apenas esses registros */
    const filtrando = filtro_aplicado !== null

    /**Lista filtrada: primeiro o filtro avançado, depois a busca por nome */
    const abastecimentos_filtrados = filtrarAvancado(
        filtro_aplicado,
        filtrando ? total_geral : listar_abastecimento
    ).filter(buscarAbastecimento(buscar_tabela))

    /**Em cima da lista completa a paginação é feita aqui, já que a API não paginou */
    const abastecimentos_exibidos = filtrando
        ? abastecimentos_filtrados.slice((page - 1) * pagination, page * pagination)
        : abastecimentos_filtrados

    const carregando = filtrando ? carregando_total : loading

    /**O relatório imprime tudo o que a tabela considera, não só a página exibida: sem filtro
     * avançado a listagem paginada traria apenas a página atual, então a base é a lista completa
    */
    const abastecimentos_relatorio = filtrando
        ? abastecimentos_filtrados
        : (total_geral ?? []).filter(buscarAbastecimento(buscar_tabela))

    /**Total do rodapé: com filtro avançado aplicado soma o resultado do filtro inteiro,
     * e não só a página exibida; sem filtro soma a lista completa */
    function calcularTotalValores(): number {
        const lista = filtrando ? abastecimentos_filtrados : (total_geral ?? [])

        return lista.reduce((soma, item) => {
            const valor = Number(item?.valor_total)

            // abastecimento na propriedade não tem valor total, e valor inválido não entra na soma
            return isFinite(valor) ? soma + valor : soma
        }, 0)
    }
    console.log('abastecimentos_exibidos', abastecimentos_exibidos)
    return (
        <Box borderless style={{ height: 'calc(100vh - 170px)' }} >
            <Inline alignItems='center'>
                <Input
                    placeholder='Buscar abastecimento'
                    value={buscar_tabela}
                    onChange={setBuscar_tabela}
                />
                <ButtonCustom icon={<FontAwesomeIcon icon={faFilter} />} type='secondary' onClick={abrirModalFiltro} >
                    Filtro avançado
                </ButtonCustom>
                <ImprimirRelatorio
                    abastecimentos={abastecimentos_relatorio}
                    intervalo_datas={filtro_aplicado?.intervalo_datas ?? []}
                    local={filtro_aplicado?.local ?? null}
                    carregando={carregando_total}
                />
                <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
                    Novo
                </ButtonCustom>
            </Inline>
            <HeaderTable
                itens={[
                    { valor: 'Data', width: '100px' },
                    { valor: 'Frota', width: '69px' },
                    { valor: 'Veículo', width: '250px' },
                    { valor: 'Nome', width: 'calc(100% - 795px)' },
                    { valor: 'Valor', width: '90px' },
                    { valor: 'Acerto', width: '120px' },
                    { valor: 'Ações', width: '160px' },
                ]}
            />

            <BodyTable
                paginate={filtrando ? abastecimentos_filtrados.length : total}
                onChangeItensPage={setPagination}
                onChangePage={setPage}
                current_page={page}
                setCurrent_page={setPage}
                totalValores={calcularTotalValores()}
                style={{
                    height: abastecimentos_exibidos.length < 8 && 'calc(100vh - 170px)',
                    position: 'relative',
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                    marginTop: -20,
                }}
            >
                <Render condition={!carregando}>
                    {abastecimentos_exibidos
                        .map((item, index) => {
                            const acerto = tipoAcerto(item?.necessario_reembolso, item?.desconto_folha)
                            const inconsistente = temInconsistencia(item?.inconsistencia)

                            return (
                                <RowTable
                                    style={{
                                        marginTop: index === 0 ? '10px' : '0px',
                                        // faixa lateral por sombra interna: uma borda de verdade somaria 3px
                                        // na largura da linha e desalinharia as colunas do cabeçalho
                                        boxShadow: inconsistente ? 'inset 3px 0 0 var(--danger-color)' : undefined,
                                    }}
                                    key={item?.cod}
                                    onDoubleClick={() => editar(item?.cod)}
                                >
                                    <RowItem fontSize={13} width={'100px'}>
                                        {dayjs(item?.data).format('DD/MM/YYYY')}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'69px'}>
                                        {item?.frota}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'250px'}>
                                        {item?.veiculo_nome}
                                    </RowItem>

                                    {/* o ícone entra na coluna `Nome` porque ela é a única de largura
                                        flexível: nas demais o texto já ocupa a largura fixa inteira */}
                                    <RowItem fontSize={13} width={'calc(100% - 789px)'} gap={8}>
                                        <Render condition={inconsistente}>
                                            <IconeInconsistencia texto={item?.inconsistencia} />
                                        </Render>
                                        {item?.usuario_nome}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'90px'}>
                                        {valorDoAbastecimento(item?.valor_total, item?.tipo_local)}
                                    </RowItem>

                                    <RowItem fontSize={13} width={'120px'}>
                                        <Tag color={acerto.cor} style={{ fontWeight: 500 }}>
                                            {acerto.label}
                                        </Tag>
                                    </RowItem>

                                    <RowItem width={'160px'} gap={10}>
                                        <DeleteButton
                                            open={confirmar_exclusao && id_item_atual === item?.cod}
                                            trigger={setConfirmar_exclusao}
                                            onTrigger={() => {
                                                setId_item_atual(item?.cod)
                                                setNome_item_atual(item?.usuario_nome)
                                            }}
                                            loading={fake_loading}
                                            message={`o item ${item?.usuario_nome} será excluido!`}
                                            deleteds={[item?.usuario_nome]}
                                            onDelete={() => {
                                                deletar(item?.cod)
                                            }}
                                            disabled={fake_loading || permissao?.exclusao === 0}
                                            disabledTrigger={permissao?.exclusao === 0}
                                        />
                                        <ButtonCustom
                                            icon={<FontAwesomeIcon icon={(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? faEye : faEdit} />}
                                            onClick={() => editar(item)}
                                            disabled={permissao?.alteracao === 0 && permissao?.acesso === 0}
                                        >
                                            {(permissao?.alteracao === 0 || permissao?.inclusao === 0) ? 'Ver' : 'Editar'}
                                        </ButtonCustom>
                                    </RowItem>
                                </RowTable>
                            )
                        })}
                </Render>

                <Render condition={abastecimentos_exibidos.length === 0 && !carregando}>
                    {buscar_tabela === '' ? (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<> Nenhum registro disponível!</>}
                        />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <>
                                    {' '}
                                    <b>'{buscar_tabela}'</b> não encontrado!
                                </>
                            }
                        />
                    )}
                </Render>

                <Render condition={carregando}>
                    <Carregando
                        animation
                        legenda='Carregando abastecimentos...'
                        justifyContent='center'
                        height={200}
                        size='default'
                    />
                </Render>
            </BodyTable>
            <ModalFiltroAbastecimento
                abrirModal={abrirModal}
                fecharModal={fecharModalAbasFiltro}
                listar_abastecimento={total_geral}
                data_postos={data_postos}
                data_propriedades={data_propriedades}
                tab_local={tab_local}
                setTab_local={setTab_local}
                intervalo_datas={intervalo_datas}
                setIntervalo_datas={setIntervalo_datas}
                fornecedor_selecionado={fornecedor_selecionado}
                setFornecedor_selecionado={setFornecedor_selecionado}
                setFornecedor_selecionado_id={setFornecedor_selecionado_id}
                propriedade_selecionada={propriedade_selecionada}
                setPropriedade_selecionada={setPropriedade_selecionada}
                setPropriedade_selecionada_id={setPropriedade_selecionada_id}
                responsavel_selecionado={responsavel_selecionado}
                setResponsavel_selecionado={setResponsavel_selecionado}
                setResponsavel_selecionado_id={setResponsavel_selecionado_id}
                frota_selecionada={frota_selecionada}
                setFrota_selecionada={setFrota_selecionada}
                forma_pagamento={forma_pagamento}
                setForma_pagamento={setForma_pagamento}
                setForma_pagamento_id={setForma_pagamento_id}
                reembolsados={reembolsados}
                setReembolsados={setReembolsados}
                descontados_folha={descontados_folha}
                setDescontados_folha={setDescontados_folha}
                somente_inconsistentes={somente_inconsistentes}
                setSomente_inconsistentes={setSomente_inconsistentes}
                filtrarAbastecimento={filtrarAbastecimento}
                limparFiltros={limparFiltros}
            />
        </Box>
    )
}